@if (isLoading$ | async) {
  <div class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>
}

<div class="mat-elevation-z8">
  <table mat-table [dataSource]="dataSource" matSort class="w-100">

    <!-- Budget Number Column -->
    <ng-container matColumnDef="budgetNr">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Budget Nr. </th>
      <td mat-cell *matCellDef="let budget"> {{budget.budgetNr}} </td>
    </ng-container>

    <!-- Budget Name Column -->
    <ng-container matColumnDef="budgetName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Budget Name </th>
      <td mat-cell *matCellDef="let budget"> {{budget.budgetName}} </td>
    </ng-container>

    <!-- Link Column -->
    <ng-container matColumnDef="link">
      <th mat-header-cell *matHeaderCellDef> Link </th>
      <td mat-cell *matCellDef="let budget">
        <a (click)="goToNewProject(budget.id)" style="cursor: pointer; text-decoration: underline;">Go to new project</a>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
</div>